import { withFormik } from 'formik';
import { defaultFormSubmit } from 'src/utils/form/submit';
import { notification } from 'src/components/Notification';
import CapBoxNew from './Capboxnew';
import schema from './schema';

export default withFormik({
  enableReinitialize: true,
  validationSchema: (props) => schema.validation(props),
  validateOnChange: false,
  validateOnBlur: true,
  mapPropsToValues: ({ capFindingsData, job, clientId }) => ({
    jobId: job.id,
    clientId,
    findings: capFindingsData?.findings.map(finding => ({
      id: finding.id || null,
      rootCause: finding.rootCause,
      modified: new Date(finding.savedAt) > new Date(finding.submittedAt),
      actions: finding.actions.map(action => ({
        id: action.id || null,
        modified: new Date(action.savedAt) > new Date(action.submittedAt),
        status: action.status || 'review_pending',
        description: action.description,
        dueDate: action.dueDate,
        actualCompletionOfActionDate: action.actualCompletionOfActionDate,
        responsiblePerson: action.responsiblePerson,
        resources: (action.resources || []).map(resource => ({
          id: resource.id,
          resourceType: resource.resourceType,
          currencyId: resource.currencyId,
          costs: resource.costs,
          details: resource.details,
          staffDayType: resource.staffDayType,
          staffDayValue: resource.staffDayValue,
          numberOfStaff: resource.numberOfStaff,
          averageDayRate: resource.averageDayRate,
        })) || [],
        attachmentIds: action.attachmentIds,
        attachmentsMeta: (action.attachmentsMeta || []).map(meta => ({
          attId: meta.attId,
          filePath: meta.filePath,
          name: meta.name,
          size: meta.size,
          type: meta.type,
        })),
        comments: (action.comments || []).map(comment => ({
          id: comment.id,
          comment: comment.comment
        })) || [],
      })) || [],
    })) || [],
  }),
  handleSubmit: async (values, form) => {
    return defaultFormSubmit(values, form);
  },
  displayName: 'CapBoxForm',
})(CapBoxNew);